"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var DropDownHeader_1 = __importDefault(require("./components/DropDownHeader"));
var DropDownHeaderSearchable_1 = __importDefault(require("./components/DropDownHeaderSearchable"));
var DropDownMultipleOption_1 = __importDefault(require("./components/DropDownMultipleOption"));
var DropDownOption_1 = __importDefault(require("./components/DropDownOption"));
var NoResultDropDownOption_1 = __importDefault(require("./components/NoResultDropDownOption"));
var DropDown_styles_1 = require("./DropDown-styles");
function onEnterOrSpace(e, callback) {
    if (e.key === 'Space' || e.key === 'Escape') {
        e.preventDefault();
        callback();
        return false;
    }
    return true;
}
function handleKeyUpDown(e) {
    var _a;
    var activeId = document.activeElement && document.activeElement.id;
    var currentIndex;
    if (!activeId) {
        return true;
    }
    if (activeId && ((_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.getAttribute('data-id')) === 't2-dropdown') {
        currentIndex = -1;
    }
    else {
        currentIndex =
            document.activeElement &&
                document.activeElement.id &&
                document.activeElement.id.includes('option-') &&
                parseInt(document.activeElement.id.replace('option-', ''), 10);
    }
    if (typeof currentIndex === 'number') {
        var nextElement = document.querySelector("#option-".concat(currentIndex + 1));
        var previousElement = document.querySelector("#option-".concat(currentIndex - 1));
        if (nextElement && e.key === 'ArrowDown') {
            nextElement.focus();
            e.preventDefault();
            return false;
        }
        if (previousElement && e.key === 'ArrowUp') {
            previousElement.focus();
            e.preventDefault();
            return false;
        }
    }
    return true;
}
function isSameOption(option1, option2) {
    return JSON.stringify(option1) === JSON.stringify(option2);
}
function getOptionHash(option) {
    var dropdownLabel = typeof option.dropdownLabel === 'string' ? option.dropdownLabel : '';
    return JSON.stringify(option.option) + dropdownLabel;
}
function getOptionsHash(options) {
    return options.reduce(function (hash, option) {
        return hash + getOptionHash(option);
    }, '');
}
function DropDown(_a) {
    var _b;
    var disabled = _a.disabled, ghost = _a.ghost, options = _a.options, onSelect = _a.onSelect, invalidSelection = _a.invalidSelection, _c = _a.isOpen, isOpen = _c === void 0 ? false : _c, _d = _a.scrollable, scrollable = _d === void 0 ? true : _d, searchable = _a.searchable, _e = _a.multipleSelectedLabel, multipleSelectedLabel = _e === void 0 ? 'Flera valda alternativ' : _e, multiSelect = _a.multiSelect, selectedOption = _a.selectedOption, selectedOptions = _a.selectedOptions, small = _a.small, title = _a.title, widthCss = _a.widthCss, props = __rest(_a, ["disabled", "ghost", "options", "onSelect", "invalidSelection", "isOpen", "scrollable", "searchable", "multipleSelectedLabel", "multiSelect", "selectedOption", "selectedOptions", "small", "title", "widthCss"]);
    var widthCssValue = widthCss || (small ? '150px' : '250px');
    var _f = React.useState(isOpen), dropdownOpen = _f[0], setDropdownOpen = _f[1];
    var _g = React.useState(), valueSelected = _g[0], setValueSelected = _g[1];
    var _h = React.useState([]), selectedOptionsState = _h[0], setSelectedOptions = _h[1];
    var _j = React.useState(''), searchTerm = _j[0], setSearchTerm = _j[1];
    var _k = React.useState(__spreadArray([], options, true)), lastOptions = _k[0], setLastOptions = _k[1];
    var _l = React.useState(__spreadArray([], options, true)), filteredOptions = _l[0], setFilteredOptions = _l[1];
    var component = React.useRef(null);
    function onKeyDown(e, callback) {
        !disabled && handleKeyUpDown(e) && onEnterOrSpace(e, callback);
    }
    React.useEffect(function () {
        if (selectedOption)
            setValueSelected(selectedOption);
    }, [selectedOption]);
    React.useEffect(function () {
        if (selectedOptions)
            setSelectedOptions(selectedOptions);
    }, [selectedOptions]);
    React.useEffect(function () {
        if (lastOptions &&
            (lastOptions.length !== options.length || getOptionsHash(lastOptions) !== getOptionsHash(options))) {
            setFilteredOptions(__spreadArray([], options, true));
            setLastOptions(__spreadArray([], options, true));
        }
    }, [lastOptions, options]);
    React.useEffect(function () {
        var listener = function (event) {
            var _a;
            if (!((_a = component === null || component === void 0 ? void 0 : component.current) === null || _a === void 0 ? void 0 : _a.contains(event.target))) {
                setDropdownOpen(false);
            }
        };
        if (dropdownOpen) {
            document.addEventListener('click', listener);
        }
        else {
            document.removeEventListener('click', listener);
        }
        return function () { return document.removeEventListener('click', listener); };
    }, [dropdownOpen]);
    function toggleDropdownOpen() {
        if (!disabled) {
            setDropdownOpen(!dropdownOpen);
        }
    }
    function selectValue(value) {
        var _a;
        toggleDropdownOpen();
        var optionToSelect = options.find(function (_a) {
            var option = _a.option;
            return isSameOption(option, value);
        });
        if (optionToSelect) {
            setValueSelected(optionToSelect);
            if (onSelect) {
                onSelect(optionToSelect.option, [optionToSelect], true);
            }
            if (searchable) {
                setSearchTerm(optionToSelect.dropdownLabel);
            }
        }
        var elementToFocus = (_a = component.current) === null || _a === void 0 ? void 0 : _a.querySelector("[data-id='t2-dropdown']");
        elementToFocus.focus();
    }
    function selectMultiValue(value) {
        var optionToSelect = options.find(function (_a) {
            var option = _a.option;
            return isSameOption(option, value);
        });
        if (optionToSelect) {
            var newSelectedOptions = void 0;
            var selected = false;
            if (selectedOptionsState.find(function (_a) {
                var option = _a.option;
                return isSameOption(option, optionToSelect.option);
            })) {
                newSelectedOptions = __spreadArray([], selectedOptionsState.filter(function (_a) {
                    var option = _a.option;
                    return !isSameOption(option, optionToSelect.option);
                }), true);
            }
            else {
                newSelectedOptions = __spreadArray(__spreadArray([], selectedOptionsState, true), [optionToSelect], false);
                selected = true;
            }
            setSelectedOptions(newSelectedOptions);
            if (onSelect) {
                onSelect(optionToSelect.option, newSelectedOptions, selected);
            }
        }
    }
    function onChangeSearch(e) {
        var target = e.target;
        var value = target.value;
        var searchTerms = value
            .toLowerCase()
            .split(' ')
            .filter(function (term) { return term !== ''; });
        var filtered = options.filter(function (option) {
            return searchTerms.every(function (term) {
                var dropdownLabel = option.dropdownLabel;
                return dropdownLabel.toLowerCase().includes(term);
            });
        });
        setFilteredOptions(filtered);
        setSearchTerm(target.value);
        setDropdownOpen(true);
    }
    var selectedTitle = undefined;
    if (valueSelected)
        selectedTitle = valueSelected.dropdownLabel;
    if (selectedOptionsState.length === 1)
        selectedTitle = selectedOptionsState[0].dropdownLabel;
    if (selectedOptionsState.length > 1)
        selectedTitle = multipleSelectedLabel;
    var dropDownBox = (_b = component === null || component === void 0 ? void 0 : component.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
    return (React.createElement(DropDown_styles_1.DropDownComponentContainer, __assign({ ref: component, style: { width: widthCssValue } }, props),
        searchable ? (React.createElement(DropDownHeaderSearchable_1.default, { disabled: disabled, ghost: ghost, onChange: onChangeSearch, onClick: toggleDropdownOpen, searchTerm: searchTerm, title: title })) : (React.createElement(DropDownHeader_1.default, { disabled: disabled, ghost: ghost, invalid: invalidSelection, onClick: toggleDropdownOpen, onKeyDown: function (e) { return onKeyDown(e, toggleDropdownOpen); }, open: dropdownOpen, selectedTitle: selectedTitle, small: small, title: title })),
        dropdownOpen && (React.createElement(DropDown_styles_1.DropDownOptions, { scrollable: scrollable, ghost: ghost, small: small, id: "t2-dropdown-options", style: { maxWidth: dropDownBox === null || dropDownBox === void 0 ? void 0 : dropDownBox.width, width: widthCssValue } },
            filteredOptions.length === 0 && React.createElement(NoResultDropDownOption_1.default, { searchable: searchable }),
            filteredOptions.map(function (option, index) {
                var isSelected = !!(selectedOptionsState.find(function (selectedOpt) {
                    return selectedOpt.option === option.option;
                }) ||
                    (valueSelected && valueSelected.option === option.option));
                return multiSelect ? (React.createElement(DropDownMultipleOption_1.default, { onClick: function (e) {
                        e.preventDefault();
                        selectMultiValue(option.option);
                    }, onKeyDown: function (e) {
                        onKeyDown(e, function () { return selectMultiValue(option.option); });
                    }, key: getOptionHash(option), optionToCreate: option, index: index, isSelected: isSelected })) : (React.createElement(DropDownOption_1.default, { onClick: function () { return selectValue(option.option); }, onKeyDown: function (e) { return onKeyDown(e, function () { return selectValue(option.option); }); }, key: getOptionHash(option), optionToCreate: option, index: index, isSelected: isSelected }));
            })))));
}
exports.default = DropDown;
